import type { ComponentProps } from 'react';

import { FinancialOnboarding as ModularFinancialOnboarding } from './onboarding/FinancialOnboarding';

export function FinancialOnboarding(
  props: ComponentProps<typeof ModularFinancialOnboarding>,
) {
  return <ModularFinancialOnboarding {...props} />;
}
